import { Box, Grid } from '@mui/material';
import { ProductsSidebar } from 'src/components/productsSidebar';
import { OOLovEditProductsComponent } from 'src/features/components/editComponentPage/forms/overrides/listingWithOptionalVisuals/LOVEditProducts';
import { OOLvgEditProductsComponent } from 'src/features/components/editComponentPage/forms/overrides/listingWithVisualGallery/LVGEditProducts';
import { ComponentTypes, IComponent } from 'src/interfaces';

import { EditComponentProps } from './EditOOComponents.interface';

export const EditOOComponents = (props: EditComponentProps) => {
  return (
    <Box data-testid="EditOOComponents">
      {props.assemblyComponent.component?.component_type?.name ===
        ComponentTypes.SINGLE_SHELF && (
        <Grid item xs={12}>
          <ProductsSidebar
            componentType={ComponentTypes.SINGLE_SHELF}
            componentConfig={props.assemblyComponent.component?.config}
            onBackClick={() => {}}
            onChangedComponentConfigField={props.onOverrideConfig}
            productCategoryIDs={
              props.assemblyComponent.component?.product_category_id
            }
            themeId={
              props.assemblyComponent.component?.theme_id ||
              props.assemblyComponent.component?.config?.themeId
            }
          />
        </Grid>
      )}

      {/*This code is commented as part of CC-15535 as OO dont have the access to override products on a PROMO Component */}

      {/* {props.assemblyComponent.component?.component_type?.name ===
        ComponentTypes.PROMOTIONAL_SPACE && (
        <Grid item xs={12}>
          <ProductsSidebar
            componentType={ComponentTypes.PROMOTIONAL_SPACE}
            componentConfig={props.assemblyComponent.component?.config}
            onBackClick={() => {}}
            onChangedComponentConfigField={props.onOverrideConfig}
            productCategoryIDs={
              props.assemblyComponent.component?.product_category_id
            }
            themeId={
              props.assemblyComponent.component?.theme_id ||
              props.assemblyComponent.component?.config?.themeId
            }
          />
        </Grid>
      )} */}

      {props.assemblyComponent.component?.component_type?.name ===
        ComponentTypes.LISTING_WITH_OPTIONAL_VISUALS && (
        <OOLovEditProductsComponent
          onOverrideConfig={props.onOverrideConfig}
          selectedComponent={props.assemblyComponent.component as IComponent}
        />
      )}

      {props.assemblyComponent.component?.component_type?.name ===
        ComponentTypes.LISTING_VISUALS_GALLERY && (
        <OOLvgEditProductsComponent
          onOverrideConfig={props.onOverrideConfig}
          selectedComponent={props.assemblyComponent.component as IComponent}
        />
      )}
    </Box>
  );
};
